var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":_vm.resetPassword}},[_vm._v("Reset password")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }